import { createContext, useContext } from 'react'
import { ProgressBarSteps } from 'src/Libs/shop/types'

interface QntmSystemConfigurationContextProps {
  activePage: number
  setActivePage: React.Dispatch<React.SetStateAction<number>>
  handleProgress: (progress: ProgressBarSteps) => void
  allowContinueMain: boolean
  setAllowContinueMain: React.Dispatch<React.SetStateAction<boolean>>
}

export const QntmSystemConfigurationContext = createContext<QntmSystemConfigurationContextProps | undefined>(undefined)

export const useQntmSystemConfigurationContext = (): QntmSystemConfigurationContextProps => {
  const context = useContext(QntmSystemConfigurationContext)

  if (!context) {
    throw new Error('useQntmSystemConfigurationContext must be used within a NormalSystemConfigurationProvider')
  }

  return context
}
